<template>
    <el-dialog :title="uploadTitle" :visible.sync="visible" width="35%" border append-to-body>
        <el-form ref="uploadData" :model="uploadData" label-width="150px">
            <picker-source :query='uploadData'></picker-source>
            <el-form-item label="是否同步云客：">
                <el-radio-group v-model="uploadData.sync_yunke">
                    <el-radio-button label="0">否</el-radio-button>
                    <el-radio-button label="1">是</el-radio-button>
                </el-radio-group> </el-form-item>
            <el-form-item v-if="type=='txt'" label="上传客资：">
                <el-upload class="upload-demo" ref="upload" :data="uploadData" accept=".txt"
                    :action="uploadUrl + '/api/customer.upload/upload'" :on-remove="handleRemove"
                    :on-success="uploadFileSuccess" :auto-upload='false' :on-change="handleChange"
                    :file-list="fileList">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item v-if="type=='input'" label="上传客资：">
                <el-input v-model="uploadData.url" type="textarea" placeholder="请输入客资"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" placeholder="请输入备注" v-model="uploadData.remark"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" v-if="type=='txt'" v-preventReClick @click="submitUpload">确认上传</el-button>
                <el-button type="success" v-if="type=='input'" v-preventReClick @click="submitUrl">确认上传</el-button>
                <el-button @click="resetForm('uploadData')">取消</el-button>
            </el-form-item>
        </el-form>

    </el-dialog>
</template>

<script>
import baseUrl from '@/utils/baseUrl';
import { preventReClick } from '@/utils/preventReClick';
import pickerSource from "@/components/picker/sourceB.vue";
// 初始参数
const uploadData = {
    source_id: 242,
    account_id: '',
    account_city_id: '',
    sync_yunke: '0',
    url: '',
    remark: ''
};
export default {
    props: {
        parent: {},
    },
    components: {
        pickerSource,
    },
    data() {
        let token = localStorage.getItem('token');
        let uploadUrl = baseUrl;
        return {
            visible: false,
            uploadData: Object.assign({}, uploadData),
            token: token,
            uploadUrl: uploadUrl,
            fileList: [],
            file: '',
            type: "",
            uploadTitle: ""
        }
    },

    methods: {
        //关闭页面 清空已添加的数据
        resetForm() {
            this.visible = false
        },
        handleRemove(file, fileList) {
            this.file = ''
        },
        handleChange(file, fileList) {
            this.file = file.name
            file.status = 'ready'
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
        },
        submitUrl() {
            let _this = this;
            console.log(this.file)
            if (this.uploadData.account_id == '') {
                _this.$message.error('请选择平台账户');
                return false
            }
            if (this.type == 'txt') {
                if (this.file == '') {
                    _this.$message.error('请上传文件');
                    return false
                }
            }
            if (this.type == 'input') {
                if (this.uploadData.url == '') {
                    _this.$message.error('上传不能为空');
                    return false
                }
            }

            this.$confirm('确定要上传, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url = '/api/customer.upload/input';
                let options = _this.uploadData;

                _this.$post(url, options).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        _this.$parent.getTableData();
                        _this.visible = false
                        _this.$message({
                            type: 'success',
                            message: res.msg
                        });

                    } else {
                        _this.$message.error(res.msg);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        submitUpload() {
            let _this = this;
            console.log(this.file)
            if (this.uploadData.account_id == '') {
                _this.$message.error('请选择平台账户');
                return false
            }
            if (this.type == 'txt') {
                if (this.file == '') {
                    _this.$message.error('请上传文件');
                    return false
                }
            }
            if (this.type == 'input') {
                if (this.uploadData.url == '') {
                    _this.$message.error('上传不能为空');
                    return false
                }
            }

            this.$confirm('确定要上传, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.upload.submit();;
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        uploadFileSuccess(res, file, flieLsit) {
            console.log(res, file, flieLsit)
            let _this = this;
            if (res.code == 200) {
                _this.$parent.getTableData();
                _this.visible = false
                _this.$message({
                    type: 'success',
                    message: res.msg
                });
            } else {
                _this.file = '';
                _this.$message({
                    type: 'warning',
                    message: res.msg
                });
            }
            if (file) {

            }
        },
        showDrawer(type) {
            console.log(type)
            let _this = this;
            _this.visible = true;
            _this.type = type;
            if (_this.type == 'txt') {
                _this.uploadTitle = '上传客资(txt)'
            }
            if (_this.type == 'input') {
                _this.uploadTitle = '上传客资(input)'
            }
            _this.uploadData = Object.assign({}, uploadData);
            _this.fileList = [],
                _this.file = '',
                _this.uploadData.token = this.token

        },
    }
}
</script>

<style scoped  lang="less">
.upload-demo {
    position: relative;
}
/deep/.el-upload--text {
    font-size: 0;
    background-color: #fff;
    border: none;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 87px;
    height: 30px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/.el-textarea {
    width: 300px;
}
</style>